const cssType = {
    informational: "row alert informational",
    confirm: "row alert confirm",
    successo: "row alert successo",
    critical: "row alert critical"
};

// const message = {
//     informational: "<strong>Informational</strong> - Quando un utente completa un'azione ma occorrono info aggiuntive",
//     confirm: "Sei sicuro di voler procedere? Una volta oscurato, questo documento <strong> non sarà visivile nel tuo Fascicolo per esempio</strong>",
//     successo: "<strong>Success</strong> - Quando un utente completa un'azione. Lorem ipsum dolor sit amet numquam suspendisse elit.",
//     critical: "<strong>Critical/Error</strong> - Quando un utente completa un' azione ma il sistema non riesce ad eseguirla.",

// };

const timeout = {
    standard_closing: 9000
};

const types = {
    informational: "informational",
    confirm: "confirm",
    successo: "successo",
    critical: "critical"
}

const icons = {
    informational: "it-info-circle",
    confirm: "it-warning-circle",
    successo: "it-check-circle",
    critical: "it-error"
}

const toasterConfig = {
    cssType: cssType,
    // message:message,
    timeout: timeout,
    types: types,
    icons: icons
};

export default toasterConfig;
